export default "__VITE_ASSET__CWnGu7us__"